import React from 'react';
import './Navbar.css';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
    return (
        <nav className="navbar">
            <ul className="navbar-links">
                <li><a href="/">Ana Sayfa</a></li>
                <li><a href="/">Piri AI</a></li>
                <li><a href="/">Atıf Ağı</a></li>
                <li><a href="/">Kurum Yayınları</a></li>
                <li><a href="/">Kelime Keşfet</a></li>
                <li><a href="/">Konu Keşfet</a></li>
                <li><a href="/">Dergi Arama</a></li>
                <li><a href="/">Veri Tabanları</a></li>
            </ul>
        </nav>
    );
};

export default Navbar;